import logo from './logo.svg';
import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
var brand;
class Car extends React.Component {
  constructor(name){
    super();
    this.brand = name;
  }
  render(){
    return(
      <div>
      <p>I am a car which is {this.props.brandname} extendenting react component.</p>
      <p id="change"></p>
      <button onClick={this.changeCar.bind(this,"Changed something!")}>Change</button>
      </div>
    );
  }
  changeCar= str =>{
    return(
      document.getElementById('change').innerHTML = str
    );
  }
  present() {
    return 'I have a ' + this.brand;
  }
  
}
var mycar = new Car("Ford");

class Form extends React.Component{
  constructor(){
    super();
    this.state = {txt: '' , name: '' ,age: null, errormessage:''};
  }
  myChangeHandler = (e) =>{
    this.setState({ txt: e.target.value});
  }
  mySubmitHandler = (event) =>{
    event.preventDefault();
    let age = this.state.age;
    if(!Number(age)){
      let err = <p className="error">Age must be number!</p>;
      this.setState({errormessage: err});
    }else{
      alert("Are u sure "+this.state.name+" "+this.state.age+" years.");
    }
    
  }
  myNameHandler = e => {
    this.setState({ name: e.target.value});
  }
  myAgeHandler = e => {
    this.setState({ age: e.target.value});
  }
  render(){
    return(
      <form action="" onSubmit={this.mySubmitHandler}>
        <p>Anything u type will be reflected</p>
        <textarea type="text" onChange={this.myChangeHandler} />
        <p> {this.state.txt} </p>
        <label htmlFor="name">Name</label>
        <input type="text" name="name" onChange={this.myNameHandler}/>
        <br/>
        <label htmlFor="age">Age :</label>
        <input type="text" name="age" onChange={this.myAgeHandler}/>
        <br/>
        <input type="submit" />
        <p>{this.state.errormessage}</p>
      </form>
    );
  }
}

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Hello World . 
          <Car brandname="Rolls Royce" />
          <Form/>
          Car : {mycar.present()} <br/>
          Author : Sahil 
        </p>
        <a
          className="App-link"
          href="https://github.com/Sahil1709"
          target="_blank"
          rel="noopener noreferrer"
        >
          My Github
        </a>
      </header>
    </div>
  );
}

export default App;
